import { Component } from '@angular/core';
import { ButtonModule } from 'primeng/button';

/**
 * Impersonation is disabled: the old server-side mechanism was unguarded and never worked with stateless tokens
 * (spec 004, FR-034, research R10). A secure, token-based version can be specified separately.
 */
@Component({
  selector: 'app-impersonate',
  imports: [ButtonModule],
  templateUrl: './impersonate.component.html',
  styleUrl: './impersonate.component.scss',
  providers: []
})
export class ImpersonateComponent {
}
